/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const AdditionalDataRoutes: Routes = [
  {
    path: RoutePaths.NEW_QUOTATION.ADDITIONAL_DATA.PARTNERSHIP.route,
    loadChildren: () =>
      import('@pages/additional-data/partnership/partnership.module').then(m => m.PartnershipPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.ADDITIONAL_DATA.POLICY_FORM.route,
    loadChildren: () =>
      import('@pages/additional-data/policy-form/policy-form.module').then(m => m.PolicyFormPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.ADDITIONAL_DATA.MORTGAGE_FORM.route,
    loadChildren: () =>
      import('@pages/additional-data/mortgage-form/mortgage-form.module').then(m => m.MortgageFormPageModule),
    canActivate: [NavigationGuard],
  },
];
